import React from 'react';
import processList from 'data/feature/processList';
import Section from 'components/common/Section';
import Process from './home/Process';
import SectionHeader from './home/SectionHeader';
import { isIterableArray } from 'helpers/utils';

const Processes = () => (
  <Section>
    <SectionHeader
      title="The Trucking Management Solution your team actually WANTS to use."
      subtitle=""
    />
    {isIterableArray(processList) &&
      processList.map((process, index) => (
        <Process key={process.color} isFirst={index === 0} {...process} />
      ))}
  </Section>
);

export default Processes;
